import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
import { useToast } from "../../Context/ToastContext";
import { useSetupProgress } from "../../Context/SetupProgressContext";
import { v2SeedDefaults } from "./SalaryApiV2";
import { WIZARD_STEP_KEY } from "./wizard/shared";
import StepPayrollSettings from "./wizard/StepPayrollSettings";
import { navigateToSettingsHome } from "../../../components/settings/settingsExit";
import "../../../styles/payroll-setup.css";
import "../../../styles/payroll-setup-wizard.css";

/**
 * Payroll Settings page (/salary-v2/setup).
 * Legacy route name kept for bookmarks and settings navigation links.
 */
export default function PayrollSetupWizard() {
  const navigate = useNavigate();
  const toast = useToast();
  const { user: me } = useContext(AuthContext);
  const { refetch: refetchSetupProgress } = useSetupProgress() || {};
  const role = (me?.role || me?.user?.role || "").toLowerCase();
  const canEdit = role === "admin" || role === "hr";
  const seededRef = useRef(false);

  useEffect(() => {
    try {
      sessionStorage.removeItem(WIZARD_STEP_KEY);
    } catch {
      /* ignore */
    }
  }, []);

  // Idempotent defaults for components/formulas (no UI); other pages may rely on this.
  useEffect(() => {
    if (seededRef.current) return;
    seededRef.current = true;
    v2SeedDefaults().catch(() => {});
  }, []);

  return (
    <div className="ps-page bw-page">
      <header className="bw-page-header ps-page-header ps-page-header--compact">
        <h1 className="bw-page-title ps-page-title">Payroll Settings</h1>
        <p className="bw-page-subtitle ps-page-subtitle">
          Pay cycle, processing day, payment date, attendance cycle, LOP rules, fuel reimbursement, and default structure.
        </p>
      </header>

      <div className="ps-panel ps-wiz-panel">
        <StepPayrollSettings
          canEdit={canEdit}
          refetchSetupProgress={refetchSetupProgress}
          toast={toast}
          onSaved={() => navigateToSettingsHome(navigate, { replace: true })}
        />
      </div>
    </div>
  );
}
